import { createSelector } from 'reselect';
import { get as lodashGet } from 'lodash';
import macheteDux from 'src/redux/machete';
import env from 'src/env';

const getActiveMeasurementCategory = (state) =>
  state.designPro.measure.activeCategoryName;
const getMeasurements = (state) => state.designPro.measure.measurements;
const getSegmentsData = (state) => state.designPro.app.segmentsData;
const isMeasureModeEnabled = (state) => !state.designPro.ui.isJobShareModalOpen;

const getUrlForSegmentsData = createSelector(
  macheteDux.selectors.getHyperionModelData,
  (model) => {
    const completeJobSegmentsUrl = lodashGet(
      model,
      'pro_premium_measurements.json.url',
    );
    const roofOnlyJobSegmentsUrl = lodashGet(
      model,
      'roof_measurements.json.url',
    );
    if (completeJobSegmentsUrl)
      return completeJobSegmentsUrl.replace(
        window.location.origin,
        env.API_SERVER,
      );
    if (roofOnlyJobSegmentsUrl)
      return roofOnlyJobSegmentsUrl.replace(
        window.location.origin,
        env.API_SERVER,
      );
    return null;
  },
);

export default {
  getActiveMeasurementCategory,
  getMeasurements,
  getSegmentsData,
  getUrlForSegmentsData,
  isMeasureModeEnabled,
};
